export const BEFORE_CREATE_ADVERT = 'BEFORE_CREATE_ADVERT';
export const CREATE_ADVERT = 'CREATE_ADVERT';
export const NETWORK_ERROR_CREATING_ADVERT = 'NETWORK_ERROR_CREATING_ADVERT';

export const BEFORE_FETCH_INITIALIZATION_DATA = 'BEFORE_FETCH_INITIALIZATION_DATA';
export const FETCH_INITIALIZATION_DATA = 'FETCH_INITIALIZATION_DATA';
export const NETWORK_ERROR_FETCHING_INITIALIZATION_DATA = 'NETWORK_ERROR_FETCHING_INITIALIZATION_DATA';